import React from 'react'

function AsyncErrorHandler({ children, FallbackComponent }) {

    const [isErrorOccurred, setIsErrorOccurred] = React.useState(false)
    const handleAsyncError = event => {
        setIsErrorOccurred(true)
        return true
    }

    React.useEffect(() => {
        window.addEventListener('unhandledrejection', handleAsyncError)
        return () => {
            window.removeEventListener('unhandledrejection', handleAsyncError)
        }

    }, [])

    if (isErrorOccurred) {
        return <FallbackComponent />
    }


    return <>{children}</>
}

export {
    AsyncErrorHandler
}